/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const SimpleFlagDescription = styled.div({
  /* This is for the flag description to render new line characters properly */
  whiteSpace: 'pre-wrap',
});
